import React, { useCallback, useEffect, useState } from 'react';
import { Carregando } from 'components/carregando';
import { Route } from 'components/route';
import { Redirect, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { CapturarErros } from 'components';
import { VariaveisAmbiente } from 'ambiente';
import { CardapioEdicao, CardapioConfiguracoes, CardapioHome, } from 'modulos/cardapio/paginas';
import { CardapioMesa } from 'modulos/cardapio/paginas/mesa';
import { CardapioQrCode } from 'modulos/cardapio/paginas/qr-code';
import { CardapioStorageKeys, useCardapioStorage } from 'storage/cardapio-storage';
import { MovSimplesProdutoModel } from 'api/cardapio/models/produto/mov-simples-produto-model';
import { useEsvaziarSacola } from 'storage';
import { useMesaStore } from 'services/store/mesa-store';
import { CardapioAcompanharPedido } from 'modulos/cardapio/paginas/acompanhar-pedido';
import { ConfirmProvider, UsuarioProvider } from 'services/providers';
import { AtualizarTemaProvider } from 'services/providers/atualizar-configuracoes-tema-provider';
import { PedidosProvider } from 'services/providers/pedidos-provider';
import { DialogModais } from 'components/dialogs/dialog-modais/dialog-modais';
import { usePessoaUsuario } from 'services/hooks/pessoa-usuario';
import { useObterToken } from 'services/store/obter-token';

export const LoginRoute = () => {
  const configuracoesRoute: string = '/configuracoes';
  const editarRoute: string = '/editar';
  const geraQrCodeRoute: string = '/gerar-qrcode';
  const acompanharPedidoRoute: string = '/pedido';
  const setToken = useObterToken(state => state.setToken)
  const isTokenExpired = useObterToken(state => state.isTokenExpired)
  const tokenValido = !isTokenExpired();
  const { empresaId, token } = useParams<any>();
  const { path: routeParams } = useRouteMatch();
  const [esvaziarSacola] = useEsvaziarSacola()
  const [carregandoInterno, setCarregandoInterno] = useState<boolean>(true)
  const { exists, delRegistro } = useCardapioStorage()
  const { location } = useHistory();

  const getMesaId = useMesaStore(state => state.getMesaId)
  const desvincularMesa = useMesaStore(state => state.desvincularMesa);
  const mesaId = getMesaId(location.pathname);
  const { carregarPessoa, carregando: carregandoPessoa } = usePessoaUsuario()

  const mesaRoute: string = `/${mesaId}/mesa`;

  const [carregandoTitulo, setarTitulo] = useState<string | undefined>(
    () => tokenValido ? undefined : 'Verificando seu usuário',
  );
  const [carregandoMsg, setarMsg] = useState<string | undefined>(
    () => tokenValido ? undefined : 'Aguarde enquanto verificamos seu usuário!',
  );
  const carregando = carregandoInterno || carregandoPessoa

  const carregarInformacoes = useCallback(async () => {
    const sacola = JSON.parse(localStorage.getItem('Sacola')!) as MovSimplesProdutoModel[];
    if (sacola) {
      const hasProdEmpresaDiferente = sacola.filter(x => x.empresaId !== empresaId).length > 0
      if (hasProdEmpresaDiferente) {
        esvaziarSacola({ empresaId })
        localStorage.removeItem('Sacola');
      }
    }
    if (!mesaId) {
      if (exists(CardapioStorageKeys.MesaAtual, false)) {
        delRegistro(CardapioStorageKeys.MesaAtual, false)
        esvaziarSacola({ empresaId })
        localStorage.removeItem('Sacola');
      }
    }
    await carregarPessoa()

    if (token || useObterToken.getState().token) {
      if (!isTokenExpired(token || useObterToken.getState().token)) {
        desvincularMesa();
        if (token) setToken(token)
      }
      if (token) {
        window.location.assign(`/${empresaId}`);
        return
      }
    }
    setarTitulo('Carregando Catálogo...');
    setarMsg('Por favor aguarde um momento enquanto localizamos o catálogo do estabelecimento.');

    setTimeout(() => {
      setCarregandoInterno(false)
    }, 500)


    sessionStorage.setItem('ultimoEmpresaId', empresaId!);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delRegistro, desvincularMesa, empresaId, esvaziarSacola, exists, isTokenExpired, mesaId, setToken, token])


  // SE O CARA MANDAR O TOKEN EU QUERO VALIDAR O ACESSO, SE ESTIVER OK QUERO REDIRECIONAR PARA O CARDAPIO DELE  
  //CARREGAMENTO DO COMPONENTE
  useEffect(() => {
    carregarInformacoes()
  }, [carregarInformacoes]);

  if (carregando) {
    return (
      <Carregando
        titulo={carregandoTitulo}
        mensagem={carregandoMsg}
        modelo="fixed"
        carregando
      />
    )
  }

  return (
    <ConfirmProvider>
      <CapturarErros>
        <Switch>
          {!carregando && (
            <AtualizarTemaProvider>
              <UsuarioProvider>
                <PedidosProvider>
                  <Switch>
                    <Route
                      exact
                      path={`${routeParams}`}
                      titulo={`${VariaveisAmbiente.appName} - Home`}
                      component={CardapioHome}
                    />

                    <Route
                      exact
                      path={`${routeParams}${mesaRoute}`}
                      titulo={`${VariaveisAmbiente.appName} - Mesa`}
                      component={CardapioMesa}
                    />

                    <Route
                      exact
                      path={`${routeParams}${editarRoute}`}
                      titulo={`${VariaveisAmbiente.appName} - Edição`}
                      component={CardapioEdicao}
                    />

                    <Route
                      exact
                      path={`${routeParams}${acompanharPedidoRoute}/:pedidoId`}
                      titulo={`${VariaveisAmbiente.appName} - Acompanhar Pedido`}
                      component={CardapioAcompanharPedido}
                    />

                    <Route
                      exact
                      path={`${routeParams}${geraQrCodeRoute}`}
                      titulo={`${VariaveisAmbiente.appName} - QrCode`}
                      component={CardapioQrCode}
                    />

                    {useObterToken.getState().token ? (
                      <Route
                        exact
                        path={`${routeParams}${configuracoesRoute}`}
                        titulo={`${VariaveisAmbiente.appName} - Configurações`}
                        component={CardapioConfiguracoes}
                      />
                    ) : (
                      <Redirect to={`/${empresaId}`} />
                    )}

                  </Switch>
                  <DialogModais />
                </PedidosProvider>
              </UsuarioProvider>
            </AtualizarTemaProvider>
          )}
          <Redirect to={`/${empresaId}`} />
        </Switch>
      </CapturarErros>
    </ConfirmProvider>
  );
};

